import React from 'react';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItemSection } from '@atlaskit/editor-toolbar';
import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
var usePluginState = conditionalHooksFactory(function () {
  return expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true);
}, function (api) {
  var _useEditorToolbar = useEditorToolbar(),
    editorViewMode = _useEditorToolbar.editorViewMode;
  return {
    editorViewMode: editorViewMode
  };
}, function (api) {
  var editorViewMode = useSharedPluginStateSelector(api, 'editorViewMode.mode');
  return {
    editorViewMode: editorViewMode
  };
});
export var MenuSection = function MenuSection(_ref) {
  var children = _ref.children,
    api = _ref.api;
  var _usePluginState = usePluginState(api),
    editorViewMode = _usePluginState.editorViewMode;
  var isEdit = editorViewMode === 'edit';
  if (!isEdit) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ToolbarDropdownItemSection, {
    hasSeparator: isEdit
  }, children);
};